module.exports = __webpack_public_path__ + "img/img20.bf984973.svg";